import { motion } from 'framer-motion';

const WorkEnvironment = () => {
  const benefits = [
    {
      icon: 'ri-team-line',
      title: 'チームワーク重視',
      description: '少人数制で風通しの良い職場環境。スタッフ同士のコミュニケーションを大切にしています。',
      image: 'https://public.readdy.ai/ai/img_res/31399306cda75db23d71f12181fcd479.jpg',
    },
    {
      icon: 'ri-book-open-line',
      title: '充実した研修制度',
      description: '定期的な研修や勉強会を実施。未経験の方でも安心してスタートできます。',
      image: 'https://readdy.ai/api/search-image?query=japanese%20healthcare%20workers%20in%20training%20session%20learning%20together%20classroom%20setting%20simple%20background%20professional%20education&width=800&height=600&seq=work-env-2&orientation=landscape',
    },
    {
      icon: 'ri-time-line',
      title: 'ワークライフバランス',
      description: 'シフト制で柔軟な働き方が可能。プライベートとの両立をサポートします。',
      image: 'https://readdy.ai/api/search-image?query=happy%20japanese%20healthcare%20worker%20relaxing%20after%20work%20peaceful%20atmosphere%20natural%20setting%20simple%20background%20work%20life%20balance&width=800&height=600&seq=work-env-3&orientation=landscape',
    },
    {
      icon: 'ri-award-line',
      title: '資格取得支援',
      description: '介護福祉士などの資格取得を全面的にバックアップ。キャリアアップを応援します。',
      image: 'https://readdy.ai/api/search-image?query=japanese%20person%20studying%20for%20healthcare%20certification%20focused%20determined%20expression%20desk%20with%20books%20simple%20background%20career%20development&width=800&height=600&seq=work-env-4&orientation=landscape',
    },
  ];

  return (
    <section className="py-16 sm:py-20 lg:py-24 bg-beige-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="text-center mb-12 sm:mb-16"
        >
          <h2 className="text-2xl sm:text-3xl md:text-4xl font-bold text-navy-800 mb-3 sm:mb-4 px-4">
            働く環境・魅力
          </h2>
          <p className="text-sm sm:text-base md:text-lg text-navy-700 px-4">
            岡山市北区で長く働ける職場環境を整えています
          </p>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 sm:gap-8 lg:gap-10">
          {benefits.map((benefit, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.6, delay: index * 0.1 }}
              className="bg-white rounded-2xl overflow-hidden shadow-md hover:shadow-lg transition-shadow"
            >
              <div className="w-full h-48 sm:h-56 overflow-hidden">
                <img
                  src={benefit.image}
                  alt={benefit.title}
                  className="w-full h-full object-cover object-center hover:scale-105 transition-transform duration-300"
                />
              </div>
              <div className="p-6 sm:p-8">
                <div className="flex items-center mb-4">
                  <div className="w-12 h-12 sm:w-14 sm:h-14 flex items-center justify-center bg-coral-500 rounded-full mr-4 flex-shrink-0">
                    <i className={`${benefit.icon} text-xl sm:text-2xl text-white`}></i>
                  </div>
                  <h3 className="text-lg sm:text-xl font-bold text-navy-800">
                    {benefit.title}
                  </h3>
                </div>
                <p className="text-sm sm:text-base text-navy-700 leading-relaxed">
                  {benefit.description}
                </p>
              </div>
            </motion.div>
          ))}
        </div>

        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="mt-12 sm:mt-16 text-center"
        >
          <h3 className="text-xl sm:text-2xl font-bold text-navy-800 mb-4 sm:mb-6 px-4">
            こんな方を求めています
          </h3>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 max-w-5xl mx-auto">
            {[
              '人と接することが好きな方',
              '岡山市北区で長く働きたい方',
              '介護の仕事に興味がある方',
              'チームワークを大切にできる方',
              '向上心を持って学べる方',
              '思いやりの心を持った方',
            ].map((item, index) => (
              <div
                key={index}
                className="bg-white rounded-xl p-4 sm:p-5 flex items-center shadow-sm"
              >
                <i className="ri-check-line text-xl sm:text-2xl text-coral-500 mr-3 flex-shrink-0"></i>
                <span className="text-sm sm:text-base text-navy-800 font-medium">
                  {item}
                </span>
              </div>
            ))}
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default WorkEnvironment;
